import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { toggleAddModal, toggleNeedRefresh } from '../../store/sportsTabSlice';
import Modal from '../../components/components/modal/modal';
import ApiService from '../../components/api_services/apiService';

import './Sports.css';

function AddSport() {
  const dispatch = useDispatch();

  const isModalOpen = useSelector((state) => state.sports.addModalOpen);

  const [formData, setFormData] = useState({
    name: '',
    englishName: '',
    thumbnail: null,
  });

  const [imagePreview, setImagePreview] = useState(null);
  const [isSubmitDisabled, setIsSubmitDisabled] = useState(true);

  useEffect(() => {
    const isValid = formData.name.trim() !== '' &&
                    formData.englishName.trim() !== '' &&
                    formData.thumbnail !== null;
    setIsSubmitDisabled(!isValid);
  }, [formData]); // Monitoruj zmiany w `formData`

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setFormData((prev) => ({ ...prev, thumbnail: file }));
      const reader = new FileReader();
      reader.onloadend = () => {
        setImagePreview(reader.result);
      };
      reader.readAsDataURL(file);
    } else {
      setFormData((prev) => ({ ...prev, thumbnail: null }));
      setImagePreview(null);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      let iconUrl = null;

      if (formData.thumbnail) {
        const uploadedImagePath = await ApiService.uploadImage(formData.thumbnail);
        iconUrl = uploadedImagePath;
      }

      const sportData = {
        name: formData.name,
        nameEng: formData.englishName,
        iconUrl: iconUrl,
      };

      const response = await ApiService.addNewSport(sportData);
      console.log('Nowy sport został dodany:', response);

      dispatch(toggleAddModal());
      dispatch(toggleNeedRefresh());
    } catch (error) {
      console.error('Błąd podczas dodawania nowego sportu:', error);
    }
  };

  const handleCloseModal = () => {
    dispatch(toggleAddModal());
  };

  return (
    <Modal isOpen={isModalOpen} onClose={handleCloseModal}>
      <h2>Dodaj dyscyplinę</h2>
      <form onSubmit={handleSubmit}>
        <div>
          <label htmlFor="name">Nazwa dyscypliny</label>
          <input
            type="text"
            id="name"
            name="name"
            value={formData.name}
            onChange={handleInputChange}
            required
          />
        </div>
        <div>
          <label htmlFor="englishName">Nazwa w języku angielskim</label>
          <input
            type="text"
            id="englishName"
            name="englishName"
            value={formData.englishName}
            onChange={handleInputChange}
            required
          />
        </div>
        <div>
          <label htmlFor="thumbnail">Miniatura</label>
          <input
            type="file"
            id="thumbnail"
            name="thumbnail"
            accept="image/*"
            onChange={handleFileChange}
          />
          {imagePreview && (
            <div className="modal-image-preview">
              <img src={imagePreview} alt="Podgląd miniatury" className="modal-image-preview-img" />
            </div>
          )}
        </div>
        <div className="modal-margin-top-20">
          <button className="buttons-modal-appearance2-almost-white" type="button" onClick={handleCloseModal}>
            Anuluj
          </button>
          <button type="submit" disabled={isSubmitDisabled}>
            Dodaj
          </button>
        </div>
      </form>
    </Modal>
  );
}

export default AddSport;